import React from "react";
import { Routes, Route } from "react-router-dom";
import ProductsList from "./product-list";
import EditProduct from "./edit-product";
import NewProduct from "./new-product";
import ProductsDetail from "./product-detail";
import NewCategory from "./new-category";
import CategoryList from "./product-category-list";

//
const Products = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<ProductsList />} />
         <Route path="/" element={<ProductsList />} />
         <Route path="/v/:url" element={<ProductsDetail />} />
         <Route path="/e/:url" element={<EditProduct />} />
         <Route path="/new" element={<NewProduct />} />
         <Route path="/categories" element={<CategoryList />} />
         <Route path="/new-cat" element={<NewCategory />} />
      </Routes>
    </React.Fragment>
  );
};

export default Products;
